import {
  Directive,
  effect,
  ElementRef,
  inject,
  input,
  OnInit,
  Renderer2,
  ViewContainerRef,
} from '@angular/core';
import { AbstractControl, NgControl } from '@angular/forms';
import { FormControlErrorComponent } from '../components/form-control-error/form-control-error.component';

@Directive({
  selector: '[appControlError]',
  standalone: true,
})
export class ControlErrorDirective implements OnInit {
  public customErrorInput = input<AbstractControl>();
  public isInvalidCondition = input(false);
  public errorClass = input('ng-custom-invalid');
  readonly #ngControl = inject(NgControl, { optional: true });
  readonly #vcr = inject(ViewContainerRef);
  readonly #renderer = inject(Renderer2);
  readonly #elementRef = inject(ElementRef);

  constructor() {
    this.#updateClassBasedOnCondition();
  }

  ngOnInit(): void {
    const formControl = this.customErrorInput() || this.#ngControl?.control;
    if (!formControl) return;

    const componentRef = this.#vcr.createComponent(FormControlErrorComponent);
    componentRef.setInput('formControl', formControl);

    const hostElement = this.#elementRef.nativeElement;
    const isPCheckbox = hostElement.tagName.toLowerCase() === 'p-checkbox';

    // w przypadku elementu p-checkbox label(z opisem) jest zazwyczaj za elementem przez co komunikat błędu pokazywał się w złym miejscu. Ten warunek jest rozwiazuje ten problem i dodaje błąd za labelem. Ważne jest to żeby label miał label for
    if (isPCheckbox) {
      const id =
        hostElement.getAttribute('inputid') || hostElement.getAttribute('id');
      if (id) {
        const label = this.#findLabelForCheckbox(id);
        if (label) {
          // Przenieś komponent błędu do po labelu
          this.#renderer.appendChild(
            label.parentElement,
            componentRef.location.nativeElement,
          );
        }
      }
    }
  }

  #findLabelForCheckbox(id: string): HTMLElement | null {
    return document.querySelector(`label[for="${id}"]`);
  }

  #updateClassBasedOnCondition(): void {
    effect(() => {
      const condition = this.isInvalidCondition();
      const className = this.errorClass();

      if (condition && className) {
        this.#renderer.addClass(this.#elementRef.nativeElement, className);
      } else {
        this.#renderer.removeClass(this.#elementRef.nativeElement, className);
      }
    });
  }
}
